export default "__VITE_ASSET__CwhXEbM3__"